// TODO: Remove eslint disable after fixing publisher backend
/* eslint-disable */
import React, { useEffect, useState } from 'react';
import {
  Row,
  Modal,
  Col,
  Select,
  Card,
  Form,
  Input,
  Typography,
  Table,
  Tag,
  Tooltip,
  DatePicker,
  Button,
  Space,
  message,
  Alert,
  Spin,
} from 'antd';
import { 
  CloseOutlined, 
  EyeOutlined, 
  ShoppingCartOutlined, 
  UserAddOutlined, 
  InfoCircleOutlined,
  DollarOutlined,
  ClockCircleOutlined
} from '@ant-design/icons';
import moment from 'moment';
import {
  PrimaryTableRowText,
  TableColumnTitle,
  StandardTableRowText,
} from '../../../shared/globalStyling/styledText';
import { formatNumber } from '../../../../core/utils/campaigns';
import SelectRetailStoresModal from './SelectRetailStoresModal';
import SelectTagsModal from './SelectTagsModal';
import { TagOutlined } from '@ant-design/icons';

const { Text, Title } = Typography;

const LaunchEditorial = ({
  tags,
  open,
  onCreate,
  onCancel,
  currentOrgId,
  filteredLocations,
  filteredAudiences,
  google,
  isSelfService,
  isUpdate = false,
  details,
  onFetchTags,
  loadingTags,
  getBasicTagActivity,
  basicTagActivity,
  tagActivityLoading,
  tagActivityError,
  clearBasicTagActivity,
}) => {
  const formattedTags =
    tags &&
    tags
      .filter(
        (tag) => tag.transactions > 0 || tag.sessions > 0 || tag.signups > 0 || tag.basketItems > 0
      )
      .map((tag) => ({
        value: tag.id,
        label: tag.name,
        orgTag: tag.orgs[0].id,
        website: tag.orgs[0].website,
        isOwned: tag.orgs[0].id === currentOrgId,
        advertiser: tag.orgs[0].name,
        transactions: tag.transactions,
        sessions: tag.sessions,
        basketItems: tag.basketItems,
        signups: tag.signups,
        appId: tag.eventTags[0].appId,
        selectedPublisherDomainOrgId: tag.orgs[0].id,
        pageViews: tag.pageViews,
        date: tag.tagUpdateDate,
        measuredEvents: [
          ...(tag.transactions > 0 ? ['TRANSACTIONS'] : []),
          ...(tag.sessions > 0 ? ['SESSIONS'] : []),
          ...(tag.basketItems > 0 ? ['BASKET_ITEMS'] : []),
          ...(tag.signups > 0 ? ['SIGN_UPS'] : []),
        ],
      }));

  // tags for publisher domains
  const publisherDomains =
    tags &&
    tags
      .filter(
        (t) =>
          (t.type.includes('PUBLISHER') || t.sessions > 0) &&
          !t.isAdvertiser &&
          t.orgs[0].id === currentOrgId
      )
      .map((tag) => {
        return {
          value: tag.id,
          label: tag.name,
          website: tag.orgs[0].website,
          orgTag: tag.orgs[0].id,
          isOwned: tag.orgs[0].id === currentOrgId,
          advertiser: tag.orgs[0].name,
          transactions: tag.transactions,
          sessions: tag.sessions,
          basketItems: tag.basketItems,
          signups: tag.signups,
          pageViews: tag.pageViews,
          selectedPublisherDomainOrgId: tag.orgs[0].id,
          appId: tag.eventTags[0].appId,
          date: tag.tagUpdateDate,
        };
      });

  const [form] = Form.useForm();
  const [selectedTags, setSelectedTags] = useState([]);
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [tagSelectionModal, setTagSelectionModal] = useState(false);
  const [retailStoresModal, setRetailStoresModal] = useState(false);
  const [selectedEventsByTag, setSelectedEventsByTag] = useState({});
  const [isLocationGroup, setIsLocationGroup] = useState(false);
  const [selectedPublisherTag, setSelectedPublisherTag] = useState(null);
  const [isUpdating, setIsUpdating] = useState(false);

  let initialValues = {};
  if (isUpdate) {
    initialValues = details;
  }
  useEffect(() => {
    if (isUpdate && open && details) {
      if (!selectedTags || selectedTags.length === 0) {
        setSelectedTags(details.measurementTags);
      }
      if (selectedLocations.length === 0) {
        setSelectedLocations(details.selectedLocations);
        setIsLocationGroup(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [details, isUpdate, open]);

  useEffect(() => {
    if (isUpdate) {
      const initialTag = publisherDomains.find(tag => tag.value === details.clicksTag.value);
      if (initialTag && !selectedPublisherTag) {
        setSelectedPublisherTag(initialTag);
      }
    }
  }, [isUpdate, details, publisherDomains]);

  useEffect(() => {
    // modal closed, reset state
    if (!open) {
      form.resetFields();
      setSelectedTags([]);
      setSelectedLocations([]);
      setIsLocationGroup(false);
      setSelectedEventsByTag({});
      setSelectedPublisherTag(null);
      setIsUpdating(false);
    }
  }, [open]);

  const onChangeClicks = (value, option) => {
    const selectedDomain = publisherDomains.find((domain) => domain.value === value);
    if (selectedDomain) {
      form.setFieldsValue({
        domain: selectedDomain.website,
        selectedPublisherDomainOrgId: selectedDomain.selectedPublisherDomainOrgId,
      });
      setSelectedPublisherTag(selectedDomain);
    }
  };

  const onSelectTags = () => {
    setTagSelectionModal(true);
  };

  const onSelectRetailStores = () => {
    setRetailStoresModal(true);
  };

  const onCloseTagsModal = () => {
    setTagSelectionModal(false);
  };

  const onCloseLocationsModal = () => {
    setRetailStoresModal(false);
  };

  const handleSelectTags = (selectedTags) => {
    const updatedTags = selectedTags.map((tag) => ({
      ...tag,
      measuredEvents: selectedEventsByTag[tag.value] || tag.measuredEvents,
    }));
    setSelectedTags(updatedTags);
    form.setFieldsValue({
      measurementTags: updatedTags,
      trackMesurements: updatedTags.flatMap((tag) => tag.measuredEvents),
    });
    onCloseTagsModal();
  };

  const handleSelectLocations = (selectedStores, isLocationGroup) => {
    setSelectedLocations(selectedStores);
    setIsLocationGroup(isLocationGroup);
    setRetailStoresModal(false);
  };

  const toggleEvent = (record, event) => {
    setSelectedEventsByTag((prev) => {
      const currentEvents = prev[record.value] || record.measuredEvents;
      let updatedEvents;

      if (currentEvents.includes(event)) {
        if (currentEvents.length === 1) {
          return prev;
        }
        updatedEvents = currentEvents.filter((e) => e !== event);
      } else {
        updatedEvents = [...currentEvents, event];
      }

      return { ...prev, [record.value]: updatedEvents };
    });
  };

  const handleRemoveTag = (tagToRemove) => {
    const updatedTags = selectedTags.filter((tag) => tag.value !== tagToRemove.value);
    setSelectedTags(updatedTags);
    form.setFieldsValue({
      measurementTags: updatedTags,
    });
  };

  const handleRemoveLocation = (locationToRemove) => {
    setSelectedLocations((prevLocations) =>
      prevLocations.filter((location) =>
        isLocationGroup ? location.id !== locationToRemove.id : location.id !== locationToRemove.id
      )
    );
  };

  const tagsColumns = [
    {
      title: <TableColumnTitle text={'Tag Name'} />,
      key: 'name',
      width: 200,
      ellipsis: true,
      render: (record) => record.label,
    },
    {
      title: <TableColumnTitle text={'Advertiser'} />,
      key: 'advertiser',
      width: 200,
      ellipsis: true,
      render: (record) => record.advertiser,
    },
    {
      title: (
        <Space>
          <TableColumnTitle text={'Events to Track'} />
          <Tooltip title="Click on events to select which user actions this tag will monitor in your reports">
            <InfoCircleOutlined style={{ color: '#1890ff', cursor: 'help' }} />
          </Tooltip>
        </Space>
      ),
      key: 'measuredEvents',
      width: '25%',
      render: (text, record) => (
        <div style={{ 
          width: '100%',
          maxWidth: '320px', 
          overflowX: 'auto',
          overflowY: 'visible',
          scrollbarWidth: 'thin'
        }}>
          <Space style={{ minWidth: 'max-content', gap: '4px' }}>
            {record.sessions > 0 && (
            <Tooltip title="Click to toggle sessions tracking">
              <Tag
                color={
                  (selectedEventsByTag[record.value] || record.measuredEvents).includes('SESSIONS')
                    ? 'success'
                    : 'default'
                }
                onClick={() => toggleEvent(record, 'SESSIONS')}
                style={{ 
                  cursor: 'pointer',
                  border: '1px solid #d9d9d9',
                  borderRadius: '4px',
                  padding: '2px 6px',
                  transition: 'all 0.3s',
                  margin: '2px'
                }}
                onMouseEnter={(e) => {
                  e.target.style.borderColor = '#1890ff';
                  e.target.style.transform = 'scale(1.02)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.borderColor = '#d9d9d9';
                  e.target.style.transform = 'scale(1)';
                }}
              >
                <Space direction="vertical" size={0} align="center">
                  <Space size={4}>
                    <EyeOutlined />
                    <Text style={{ fontSize: '12px' }}>Sessions</Text>
                  </Space>
                  <Space size={2}>
                    <Text strong style={{ fontSize: '14px' }}>{formatNumber(record.sessions)}</Text>
                    {record.date && (
                      <Tooltip title={`Last tested: ${moment(record.date).format('YYYY/MM/DD HH:mm:ss')}`}>
                        <ClockCircleOutlined style={{ fontSize: '10px', color: '#999' }} />
                      </Tooltip>
                    )}
                  </Space>
                </Space>
              </Tag>
            </Tooltip>
          )}
          {record.transactions > 0 && (
            <Tooltip title="Click to toggle transaction tracking">
              <Tag
                color={
                  (selectedEventsByTag[record.value] || record.measuredEvents).includes(
                    'TRANSACTIONS'
                  )
                    ? 'success'
                    : 'default'
                }
                onClick={() => toggleEvent(record, 'TRANSACTIONS')}
                style={{ 
                  cursor: 'pointer',
                  border: '1px solid #d9d9d9',
                  borderRadius: '4px',
                  padding: '2px 6px',
                  transition: 'all 0.3s',
                  margin: '2px'
                }}
                onMouseEnter={(e) => {
                  e.target.style.borderColor = '#1890ff';
                  e.target.style.transform = 'scale(1.02)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.borderColor = '#d9d9d9';
                  e.target.style.transform = 'scale(1)';
                }}
              >
                <Space direction="vertical" size={0} align="center">
                  <Space size={4}>
                    <DollarOutlined />
                    <Text style={{ fontSize: '12px' }}>Transactions</Text>
                  </Space>
                  <Space size={2}>
                    <Text strong style={{ fontSize: '14px' }}>{formatNumber(record.transactions)}</Text>
                    {record.date && (
                      <Tooltip title={`Last tested: ${moment(record.date).format('YYYY/MM/DD HH:mm:ss')}`}>
                        <ClockCircleOutlined style={{ fontSize: '10px', color: '#999' }} />
                      </Tooltip>
                    )}
                  </Space>
                </Space>
              </Tag>
            </Tooltip>
          )}
          {record.signups > 0 && (
            <Tooltip title="Click to toggle sign-up tracking">
              <Tag
                color={
                  (selectedEventsByTag[record.value] || record.measuredEvents).includes('SIGN_UPS')
                    ? 'success'
                    : 'default'
                }
                onClick={() => toggleEvent(record, 'SIGN_UPS')}
                style={{ 
                  cursor: 'pointer',
                  border: '1px solid #d9d9d9',
                  borderRadius: '4px',
                  padding: '2px 6px',
                  transition: 'all 0.3s',
                  margin: '2px'
                }}
                onMouseEnter={(e) => {
                  e.target.style.borderColor = '#1890ff';
                  e.target.style.transform = 'scale(1.02)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.borderColor = '#d9d9d9';
                  e.target.style.transform = 'scale(1)';
                }}
              >
                <Space direction="vertical" size={0} align="center">
                  <Space size={4}>
                    <UserAddOutlined />
                    <Text style={{ fontSize: '12px' }}>Sign-Ups</Text>
                  </Space>
                  <Space size={2}>
                    <Text strong style={{ fontSize: '14px' }}>{formatNumber(record.signups)}</Text>
                    {record.date && (
                      <Tooltip title={`Last tested: ${moment(record.date).format('YYYY/MM/DD HH:mm:ss')}`}>
                        <ClockCircleOutlined style={{ fontSize: '10px', color: '#999' }} />
                      </Tooltip>
                    )}
                  </Space>
                </Space>
              </Tag>
            </Tooltip>
          )}
          {record.basketItems > 0 && (
            <Tooltip title="Click to toggle basket item tracking">
              <Tag
                color={
                  (selectedEventsByTag[record.value] || record.measuredEvents).includes(
                    'BASKET_ITEMS'
                  )
                    ? 'success'
                    : 'default'
                }
                onClick={() => toggleEvent(record, 'BASKET_ITEMS')}
                style={{ 
                  cursor: 'pointer',
                  border: '1px solid #d9d9d9',
                  borderRadius: '4px',
                  padding: '2px 6px',
                  transition: 'all 0.3s',
                  margin: '2px'
                }}
                onMouseEnter={(e) => {
                  e.target.style.borderColor = '#1890ff';
                  e.target.style.transform = 'scale(1.02)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.borderColor = '#d9d9d9';
                  e.target.style.transform = 'scale(1)';
                }}
              >
                <Space direction="vertical" size={0} align="center">
                  <Space size={4}>
                    <ShoppingCartOutlined />
                    <Text style={{ fontSize: '12px' }}>Basket Items</Text>
                  </Space>
                  <Space size={2}>
                    <Text strong style={{ fontSize: '14px' }}>{formatNumber(record.basketItems)}</Text>
                    {record.date && (
                      <Tooltip title={`Last tested: ${moment(record.date).format('YYYY/MM/DD HH:mm:ss')}`}>
                        <ClockCircleOutlined style={{ fontSize: '10px', color: '#999' }} />
                      </Tooltip>
                    )}
                  </Space>
                </Space>
              </Tag>
            </Tooltip>
          )}
          </Space>
        </div>
      ),
    },
    {
      title: <TableColumnTitle text={'Tag ID'} />,
      key: 'appId',
      width: 350,
      render: (record) => <Typography.Paragraph copyable>{record.appId}</Typography.Paragraph>,
    },
    {
      title: 'Action',
      key: 'action',
      width: 150,
      render: (record) => {
        const tagId = record.value || record.id;
        const appId = record.appId;
        const orgId = record.orgTag;

        return (
          <div style={{ marginTop: -14 }}>
            <Button
              color="primary"
              variant="filled"
              icon={<TagOutlined />} // Added tag icon
              onClick={async (event) => {
                event.stopPropagation();
                handleTestSignal({ appId, orgId, tagId });
              }}
            >
              Test Signal
            </Button>
          </div>
        );
      },
    },
  ];

  const handleTestSignal = ({ appId, orgId, tagId }) => {
    getBasicTagActivity({
      variables: {
        appId: Array.isArray(appId) ? appId[0] : appId,
        orgId,
        tagId,
      },
    });
  };

  useEffect(() => {
    if (basicTagActivity) {
      message.success('Signal Tested Successfully', 3);
      onFetchTags();
      clearBasicTagActivity();
    } else if (basicTagActivity == "") {
      message.error('Error Testing Signal: cannot fetch tag activity');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [basicTagActivity]);

  // Update selectedPublisherTag when tags are refetched
  useEffect(() => {
    if (selectedPublisherTag && publisherDomains) {
      const updatedTag = publisherDomains.find(tag => tag.value === selectedPublisherTag.value);
      if (updatedTag && updatedTag.date !== selectedPublisherTag.date) {
        setSelectedPublisherTag(updatedTag);
      }
    }
  }, [publisherDomains]);

  useEffect(() => {
    if (tagActivityError) {
      message.error(tagActivityError.message || 'Error fetching signal', 3);
    }
  }, [tagActivityError]);

  const selectedTagsColumns = [
    {
      title: 'Tag Name',
      dataIndex: 'label',
      key: 'label',
    },
    {
      title: 'Measured Events',
      key: 'measuredEvents',
      render: (_, record) => (
        <Space>
          {record.measuredEvents.map((event) => (
            <Tag key={event} color="success">
              {event.replace('_', ' ')}
            </Tag>
          ))}
        </Space>
      ),
    },
    {
      title: 'Tag ID',
      dataIndex: 'appId',
      key: 'appId',
      render: (text) => <Typography.Text copyable>{text}</Typography.Text>,
    },
    {
      title: '',
      key: 'delete',
      width: 50,
      render: (_, record) => (
        <Button
          type="text"
          danger
          onClick={() => handleRemoveTag(record)}
          icon={<CloseOutlined />}
          aria-label="Remove tag"
        />
      ),
    },
  ];

  const locationColumns = [
    {
      title: 'Location Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Street Address',
      key: 'street',
      render: (text, record) => `${record.street}, ${record.city} ${record.state}, ${record.zip}`,
    },
    {
      title: 'Created On',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (text) => new Date(text).toLocaleString(),
    },
    {
      title: '',
      key: 'delete',
      width: 50,
      render: (_, record) => (
        <Button
          type="text"
          danger
          onClick={() => handleRemoveLocation(record)}
          icon={<CloseOutlined />}
          aria-label="Remove location"
        />
      ),
    },
  ];

  const locationGroupColumns = [
    {
      title: 'Region Group Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Locations',
      dataIndex: 'geoTargets',
      key: 'locations',
      render: function (geoTargets) {
        if (!geoTargets || !Array.isArray(geoTargets)) {
          return null;
        }
        return (
          <Space wrap>
            {geoTargets.map((gt) => (
              <Tag key={gt.id} color="blue">
                {gt.name}
              </Tag>
            ))}
          </Space>
        );
      },
    },
    {
      title: '',
      key: 'delete',
      width: 50,
      render: (_, record) => (
        <Button
          type="text"
          danger
          onClick={() => handleRemoveLocation(record)}
          icon={<CloseOutlined />}
          aria-label="Remove location group"
        />
      ),
    },
  ];

  return (
    <Modal
      title={`${isUpdate ? 'Update' : 'Add'} Publisher Funnel`}
      visible={open}
      okText={isUpdate ? 'Update' : 'Launch'}
      cancelText="Cancel"
      width={'75%'}
      confirmLoading={isUpdating}
      onOk={async () => {
        if (isUpdating) return; // Prevent multiple clicks
        
        try {
          setIsUpdating(true);
          const values = await form.validateFields();
          
          const formattedValues = {
            ...values,
            clicksTag:
              typeof values.clicksTag === 'object' ? values.clicksTag.value : values.clicksTag,
            startDate: values.startDate.toISOString(),
            endDate: values.endDate.toISOString(),
            transactionsTags: selectedTags.map((tag) => ({
              eventsTarget: { connect: { id: tag.value, orgId: tag.orgTag } },
              trackMesurements: { set: tag.measuredEvents },
            })),
            locations: {
              connect: isLocationGroup
                ? selectedLocations.flatMap((group) =>
                    (group.geoTargets || [])
                      .map((loc) => ({
                        id: loc.location && loc.location.id ? loc.location.id : null,
                      }))
                      .filter((item) => item.id != null)
                  )
                : (selectedLocations || [])
                    .map((location) => ({
                      id: location && location.id ? location.id : null,
                    }))
                    .filter((item) => item.id != null),
            },
          };
          
          await onCreate(formattedValues);
          form.resetFields();
          setSelectedTags([]);
          setSelectedLocations([]);
          setIsLocationGroup(false);
          onCancel();
        } catch (error) {
          message.error('Please ensure all required fields are filled correctly.');
        } finally {
          setIsUpdating(false);
        }
      }}
      onCancel={onCancel}
    >
      <Card title={'Funnel Details'}>
        <Form
          form={form}
          layout="vertical"
          name={'launchEditorialForm'}
          initialValues={initialValues}
        >
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <Form.Item
                name={'name'}
                label={<Text strong>Funnel Name</Text>}
                rules={[{ required: true, message: 'Funnel Name Required' }]}
              >
                <Input placeholder="Enter Funnel Name" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <Spin spinning={tagActivityLoading || loadingTags}>
                <Form.Item
                  name={'clicksTag'}
                  label={
                    <Row>
                      <Col span={24}>
                        <Title level={5}>Publisher Domain</Title>
                      </Col>
                      <Col span={24}>
                        <Text type="secondary">Select Publisher Domain Tag for this funnel</Text>
                      </Col>
                    </Row>
                  }
                  rules={[{ required: true, message: 'Please select a tag' }]}
                >
                  <Select
                    style={{ width: '100%' }}
                    placeholder="Select Clicks Tag"
                    showSearch={true}
                    getPopupContainer={(trigger) => trigger.parentNode}
                    filterOption={(input, option) => {
                      if (option.label.toLowerCase().includes(input.toLowerCase())) return true;
                    }}
                    options={publisherDomains}
                    filterSort={(optionA, optionB) =>
                      optionA.label.toLowerCase().localeCompare(optionB.label.toLowerCase())
                    }
                    onChange={onChangeClicks}
                  />
                </Form.Item>
                {selectedPublisherTag && (() => {
                  if (!selectedPublisherTag) return null;

                  return (
                    <div style={{ marginTop: '10px', marginBottom: '14px' }}>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          gap: '12px',
                          flexWrap: 'wrap',
                        }}
                      >
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
                          <Tag color={selectedPublisherTag.pageViews > 0 ? "green" : "red"}>
                            <Space direction="vertical" size={0}>
                              <Text strong>Page Views</Text>
                              <Text type="secondary">
                                {formatNumber(selectedPublisherTag.pageViews || 0)}
                              </Text>
                              <Text type="secondary">
                                {selectedPublisherTag.date
                                  ? moment(selectedPublisherTag.date).format('YYYY/MM/DD HH:mm:ss')
                                  : 'Signal Unknown'}
                              </Text>
                            </Space>
                          </Tag>
                        </div>
                        <Button
                          color="primary"
                          variant="filled"
                          icon={<TagOutlined />}
                          onClick={async (event) => {
                            event.stopPropagation();
                            if (
                              selectedPublisherTag.appId &&
                              selectedPublisherTag.orgTag &&
                              selectedPublisherTag.value
                            ) {
                              handleTestSignal({
                                appId: selectedPublisherTag.appId,
                                orgId: selectedPublisherTag.orgTag,
                                tagId: selectedPublisherTag.value,
                              });
                            }
                          }}
                        >
                          Test Signal
                        </Button>
                      </div>
                    </div>
                  );
                })()}
              </Spin>
            </Col>
            <Col span={12}>
              <Form.Item
                name={'url'}
                label={
                  <Row>
                    <Col span={24}>
                      <Title level={5}>Funnel URL (Optional)</Title>
                    </Col>
                    <Col span={24}>
                      <Text type="secondary">
                        Enter one or more specific sub pages to measure. Leave blank to measure the
                        entire domain
                      </Text>
                    </Col>
                  </Row>
                }
                rules={[
                  {
                    validator: (_, value) => {
                      // Check if value has '/' at the start
                      const urlArrays = value;
                      if (urlArrays) {
                        for (let i = 0; i < urlArrays.length; i++) {
                          if (urlArrays[i].charAt(0) !== '/') {
                            return Promise.reject(
                              new Error(`URL ${urlArrays[i]} must start with /`)
                            );
                          }
                        }
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <Select
                  mode="tags"
                  style={{ width: '100%' }}
                  placeholder="/page.html"
                  allowClear={true}
                  notFoundContent={null}
                  getPopupContainer={(trigger) => trigger.parentNode}
                />
              </Form.Item>
              <Form.Item name="selectedPublisherDomainOrgId" hidden>
                <Input />
              </Form.Item>
              <Form.Item name="domain" hidden>
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16, 16]}>
            <Col span={6}>
              <Form.Item
                name={'startDate'}
                label={<Text strong>Start Date</Text>}
                rules={[
                  { required: true, message: 'Start Date is Required' },
                  {
                    validator: (_, value) => {
                      const endDate = form.getFieldValue('endDate');
                      if (value && endDate && value.isAfter(endDate)) {
                        return Promise.reject(new Error('Start Date must be before End Date'));
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <DatePicker
                  style={{ width: '100%' }}
                  getPopupContainer={(trigger) => trigger.parentNode}
                  onChange={() => {
                    form.validateFields(['endDate']);
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name={'endDate'}
                label={<Text strong>End Date</Text>}
                rules={[
                  { required: true, message: 'End Date is Required' },
                  {
                    validator: (_, value) => {
                      const startDate = form.getFieldValue('startDate');
                      if (value && startDate && value.isBefore(startDate)) {
                        return Promise.reject(new Error('End Date must be after Start Date'));
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <DatePicker
                  style={{ width: '100%' }}
                  getPopupContainer={(trigger) => trigger.parentNode}
                  disabledDate={(current) => current && current < moment().endOf('day')}
                  onChange={() => {
                    form.validateFields(['startDate']);
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item
            name="measurementTags"
            rules={[
              {
                validator: (_, value) => {
                  if (!selectedTags || selectedTags.length === 0) {
                    return Promise.reject(new Error('Please select at least one measurement tag'));
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <Input type="hidden" />
          </Form.Item>
          <Card
            title="MEASUREMENT TAGS"
            style={{ marginBottom: '16px' }}
            extra={selectedTags.length > 0 && <Button onClick={onSelectTags}>Edit Tags</Button>}
          >
            {selectedTags.length === 0 ? (
              <>
                <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                  Select 1 or more measurement tags for this funnel from your library
                </div>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100%',
                  }}
                >
                  <Button type="primary" onClick={onSelectTags}>
                    Select Tags
                  </Button>
                </div>
              </>
            ) : (
              <Table dataSource={selectedTags} columns={selectedTagsColumns} pagination={false} />
            )}
          </Card>
          <Card
            title="RETAIL STORES"
            extra={
              selectedLocations.length > 0 && (
                <Button onClick={onSelectRetailStores}>Edit Stores</Button>
              )
            }
          >
            {selectedLocations.length === 0 ? (
              <>
                <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                  Select retail stores from your library in order to attribute transactions with
                  store locations
                </div>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100%',
                  }}
                >
                  <Button type="primary" onClick={onSelectRetailStores}>
                    Select Stores
                  </Button>
                </div>
              </>
            ) : (
              <Table
                dataSource={selectedLocations}
                columns={isLocationGroup ? locationGroupColumns : locationColumns}
                pagination={false}
              />
            )}
          </Card>
        </Form>
      </Card>
      {tagSelectionModal && (
        <Modal
          visible={tagSelectionModal}
          onCancel={onCloseTagsModal}
          footer={null}
          width={1200}
          bodyStyle={{ padding: '16px' }}
        >
          <Spin spinning={loadingTags || tagActivityLoading}>
            <Alert
            message="Select Events to Track"
            description="Choose which user actions each measurement tag will monitor. Click on the colored event cards to toggle tracking on/off. Selected events (green) will appear in your reports."
            type="info"
            showIcon
            style={{ marginBottom: '16px' }}
          />
          <SelectTagsModal
              formattedTags={formattedTags}
              onSelectTags={handleSelectTags}
              tagsColumns={tagsColumns}
              selectedTags={selectedTags}
            />
          </Spin>
        </Modal>
      )}
      {retailStoresModal && isSelfService && (
        <Modal
          visible={retailStoresModal}
          onCancel={onCloseLocationsModal}
          footer={null}
          width={1200}
          bodyStyle={{ padding: '0' }}
        >
          <SelectRetailStoresModal
            visible={retailStoresModal}
            onClose={onCloseLocationsModal}
            filteredLocations={filteredLocations}
            filteredAudiences={filteredAudiences}
            onSelectStores={handleSelectLocations}
            google={google}
          />
        </Modal>
      )}
    </Modal>
  );
};

export default LaunchEditorial;
